<template>
    <div>
        <loader-list v-if="isLoading" />
        <form
            v-else
            ref="staff-new-form"
            class="d-flex flex-column flex-md-row gap"
        >
            <div class="w-50" v-if="!isEditStaff">
                <b-img src="/apps/assets/img/no_avatar.png" class="photo" />
            </div>

            <div class="w-100">
                <b-form-group
                    label="First Name:"
                    label-for="firstname"
                    label-cols-sm="4"
                >
                    <b-form-input
                        id="firstname"
                        v-model="details.firstname"
                        name="firstname"
                        class="form-control"
                        type="text"
                        placeholder="First Name (required)"
                        v-validate="'required'"
                        trim
                        :disabled="isEditStaff && details.is_whitelist"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Last Name:"
                    label-for="lastname"
                    label-cols-sm="4"
                >
                    <b-form-input
                        id="lastname"
                        v-model="details.lastname"
                        name="lastname"
                        class="form-control"
                        type="text"
                        placeholder="Last Name (required)"
                        v-validate="'required'"
                        trim
                        :disabled="isEditStaff && details.is_whitelist"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Title:"
                    label-for="title"
                    label-cols-sm="4"
                >
                    <b-form-input
                        id="title"
                        v-model="details.title"
                        name="title"
                        class="form-control"
                        type="text"
                        placeholder="Title (optional)"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Role:" label-for="role" label-cols-sm="4">
                    <b-select
                        v-model="details.role_id"
                        :options="roleOptions"
                        name="role_id"
                    ></b-select>
                </b-form-group>

                <b-form-group
                    label="Provider:"
                    label-for="Provider"
                    label-cols-sm="4"
                >
                    <b-select
                        v-model="details.is_provider"
                        :options="providerOptions"
                        name="is_provider"
                    ></b-select>
                </b-form-group>

                <b-form-group
                    label="Pay Type:"
                    label-for="payType"
                    label-cols-sm="4"
                >
                    <b-select
                        v-model="details.pay_type"
                        :options="payTypeOptions"
                        name="pay_type"
                    ></b-select>
                </b-form-group>

                <b-form-group
                    label="License:"
                    label-for="license"
                    label-cols-sm="4"
                >
                    <b-form-input
                        id="license"
                        v-model="details.license"
                        name="license"
                        class="form-control"
                        type="text"
                        placeholder="License (optional)"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="DEA:" label-for="dea" label-cols-sm="4">
                    <b-form-input
                        id="dea"
                        v-model="details.dea"
                        name="dea"
                        class="form-control"
                        type="text"
                        placeholder="DEA (optional)"
                        trim
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="w-100">
                <b-form-group
                    label="Email:"
                    label-for="email"
                    label-cols-sm="4"
                >
                    <b-form-input
                        id="email"
                        v-model="details.email"
                        name="email"
                        class="form-control"
                        type="email"
                        placeholder="Email (required)"
                        :class="{
                            'border-danger': errors.has('email')
                        }"
                        v-validate="'email|required'"
                        trim
                        :disabled="isEditStaff && details.is_whitelist"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Home:"
                    label-for="homeCountryCode"
                    label-cols-sm="4"
                >
                    <b-row>
                        <b-col sm="4" class="pr-0">
                            <country-code
                                class="form-control"
                                :defaultValue="$root.setting.phone_code"
                                v-model="details.home_country_code"
                            />
                        </b-col>
                        <b-col class="pl-2">
                            <b-form-input
                                id="homePhone"
                                v-model="details.home"
                                name="homePhone"
                                class="form-control"
                                type="text"
                                placeholder="Home (optional)"
                                v-validate="'international_phone'"
                                :class="{
                                    'border-danger': errors.has('homePhone')
                                }"
                                trim
                            ></b-form-input>
                        </b-col>
                    </b-row>
                </b-form-group>

                <b-form-group
                    label="Mobile:"
                    label-for="mobileCountryCode"
                    label-cols-sm="4"
                >
                    <b-row>
                        <b-col sm="4" class="pr-0">
                            <country-code
                                class="form-control"
                                :defaultValue="$root.setting.phone_code"
                                v-model="details.mobile_country_code"
                            />
                        </b-col>
                        <b-col class="pl-2">
                            <b-form-input
                                id="mobilePhone"
                                v-model="details.mobile"
                                name="mobilePhone"
                                class="form-control"
                                type="text"
                                placeholder="Mobile (optional)"
                                v-validate="'international_phone'"
                                :class="{
                                    'border-danger': errors.has('mobilePhone')
                                }"
                                trim
                            ></b-form-input>
                        </b-col>
                    </b-row>
                </b-form-group>

                <b-form-group
                    label="Address:"
                    label-for="address"
                    label-cols-sm="4"
                >
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="address"
                            v-model="details.address"
                            module="address"
                            class="form-control"
                            placeholder="Address (optional)"
                            name="address"
                        />
                    </div>
                    <div v-else>
                        <v-address-picker-aws
                            id="address"
                            v-model="details.address"
                            module="address"
                            placeholder="Address (optional)"
                            name="address"
                        />
                    </div>
                </b-form-group>

                <b-form-group label="City:" label-for="city" label-cols-sm="4">
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="city"
                            v-model="details.city"
                            module="city"
                            class="form-control"
                            placeholder="City (optional)"
                            name="city"
                        />
                    </div>
                    <div v-else>
                        <b-form-input
                            id="city"
                            v-model="details.city"
                            module="city"
                            placeholder="City (optional)"
                            name="city"
                            trim
                        />
                    </div>
                </b-form-group>

                <b-form-group
                    label="State:"
                    label-for="state"
                    label-cols-sm="4"
                >
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="state"
                            v-model="details.state"
                            module="state"
                            name="state"
                            class="form-control"
                            placeholder="State (optional)"
                        />
                    </div>
                    <div v-else>
                        <b-form-input
                            id="state"
                            v-model="details.state"
                            module="state"
                            name="state"
                            placeholder="State (optional)"
                            trim
                        />
                    </div>
                </b-form-group>

                <b-form-group
                    label="Zipcode:"
                    label-for="zipcode"
                    label-cols-sm="4"
                >
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="zipcode"
                            v-model="details.zipcode"
                            module="zipcode"
                            name="zipcode"
                            class="form-control"
                            placeholder="Zipcode (optional)"
                        />
                    </div>
                    <div v-else>
                        <b-form-input
                            module="zipcode"
                            id="zipcode"
                            v-model="details.zipcode"
                            name="zipcode"
                            placeholder="Zipcode (optional)"
                            trim
                        />
                    </div>
                </b-form-group>

                <b-form-group
                    label="Country:"
                    label-for="country"
                    label-cols-sm="4"
                >
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="country"
                            v-model="details.country"
                            module="country"
                            name="country"
                            class="form-control"
                            placeholder="Country (optional)"
                        />
                    </div>
                    <div v-else>
                        <b-form-input
                            id="country"
                            v-model="details.country"
                            module="country"
                            name="country"
                            placeholder="Country (optional)"
                            trim
                        />
                    </div>
                </b-form-group>

                <b-form-group
                    hidden
                    label="County:"
                    label-for="county"
                    label-cols-sm="4"
                >
                    <div v-if="use_google_location">
                        <v-address-picker
                            id="county"
                            v-model="details.county"
                            module="county"
                            name="county"
                            class="form-control"
                            placeholder="County (optional)"
                        />
                    </div>
                    <div v-else>
                        <b-form-input
                            id="county"
                            v-model="details.county"
                            module="county"
                            name="county"
                            placeholder="County (optional)"
                            trim
                        />
                    </div>
                </b-form-group>
            </div>
            <div class="w-100">
                <b-form-group
                    label="After-Hours:"
                    label-for="restricted_after_office_access"
                    label-cols-sm="4"
                >
                    <b-select
                        v-model="details.restricted_after_office_access"
                        :options="restrictedAfterOfficeAccessOptions"
                        name="restricted_after_office_access"
                    ></b-select>
                </b-form-group>

                <b-form-group
                    label="Timezone:"
                    label-for="timezone"
                    label-cols-sm="4"
                >
                    <b-select
                        v-model="details.timezone"
                        :options="timezoneOptions"
                        name="timezone"
                    ></b-select>
                </b-form-group>

                <div
                    v-if="!isNotifcationFeatureEnabled"
                    class="form-row form-group"
                >
                    <label
                        for="default_task_receiver"
                        class="col-sm-4 col-form-label pt-0"
                        v-b-tooltip.hover="{
                            placement: 'top',
                            title: 'Receive unassigned tasks automatically'
                        }"
                        >Default Task Receiver
                        <i class="cus-information mr-0"></i>:
                    </label>
                    <div class="bv-no-focus-ring col">
                        <b-select
                            v-model="details.unassigned"
                            :options="defaultTaskReceiverOptions"
                            name="default_task_receiver"
                        ></b-select>
                    </div>
                </div>

                <b-form-group
                    v-if="
                        details.is_provider && productionCreditsOptions.length
                    "
                    label="Production Credit:"
                    label-for="production_credit_id"
                    label-cols-sm="4"
                >
                    <b-select
                        v-model="details.production_credit_id"
                        :options="productionCreditsOptions"
                        name="production_credit_id"
                    ></b-select>
                </b-form-group>
            </div>
        </form>
    </div>
</template>

<script>
import CountryCode from "@/module/commons/countrycode";
import vAddressPicker from "@/module/commons/vet-address.vue";
import vAddressPickerAws from "@/module/commons/vet-address-aws.vue";
import staffService from "@/services/staff";
import getTimezoneList from "@/utils/get-timezone-list";
import { pick, assign } from "lodash";
import LoaderList from "@/components/elements/loader-list";
import FeaturesEnabledMixin from "@/mixins/features-enabled";

export default {
    name: "staffDetailsForm",
    components: {
        CountryCode,
        vAddressPicker,
        vAddressPickerAws,
        LoaderList
    },
    mixins: [FeaturesEnabledMixin],
    data() {
        return {
            roleOptions: [],
            productionCreditsOptions: []
        };
    },
    props: {
        isEditStaff: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        timezoneOptions() {
            return [
                {
                    value: 0,
                    text: "Default to clinic timezone"
                },
                ...getTimezoneList()
            ];
        },
        providerOptions() {
            return [
                {
                    value: 0,
                    text: "No"
                },
                {
                    value: 1,
                    text: "Yes"
                }
            ];
        },
        payTypeOptions() {
            return [
                {
                    value: 1,
                    text: "Hourly"
                },
                {
                    value: 2,
                    text: "Salaried"
                }
            ];
        },
        restrictedAfterOfficeAccessOptions() {
            return [
                {
                    value: 0,
                    text: "Cannot log in after hours"
                },
                {
                    value: 1,
                    text: "Can log in after hours"
                }
            ];
        },
        defaultTaskReceiverOptions() {
            return [
                {
                    value: 1,
                    text: "Yes"
                },
                {
                    value: 0,
                    text: "No"
                }
            ];
        },
        details() {
            if (this.isEditStaff) {
                const newDetails = this.$store.getters["staff/newDetails"];
                const staffDetails = this.$store.getters["staff/staffDetails"];

                const currentDetails = assign(
                    {},
                    newDetails,
                    pick(staffDetails, Object.keys(newDetails))
                );

                this.$store.commit("staff/setNewDetails", {
                    id: staffDetails.id,
                    ...currentDetails
                });
            }

            return this.$store.getters["staff/newDetails"];
        },
        use_google_location() {
            return process.env.USE_GOOGLE_LOCATION === "true" ? true : false;
        },
        isLoading() {
            return (
                this.$store.getters["staff/isLoadingDetailsForm"] ||
                !this.roleOptions.length
            );
        }
    },
    created() {
        this.getBalanceQuota();
        this.getRoleOptions();
        this.getProductionCreditsOptions();
        this.addressPicked();
    },
    mounted() {},
    beforeDestroy() {
        this.$store.commit("staff/clearNewDetails");
    },
    methods: {
        async getBalanceQuota() {
            const res = await staffService.getBalanceQuota();

            if (res && res.code == 200 && res.resource) {
                this.$store.commit(
                    "staff/setQuota",
                    res.resource.userBalanceQuota
                );
            }
        },
        async getRoleOptions() {
            const res = await staffService.getRoles();
            if (res && res.resources && res.resources.length) {
                this.roleOptions = res.resources.map(role => {
                    return {
                        text: role.name,
                        value: role.id
                    };
                });

                if (!this.details.role_id) {
                    this.details.role_id = this.roleOptions[0].value;
                }
            }
        },
        async getProductionCreditsOptions() {
            const productionCredits = await staffService.getProductionCredits();

            if (productionCredits && productionCredits.length) {
                this.productionCreditsOptions = productionCredits.map(
                    productionCredit => {
                        return {
                            text: productionCredit.name,
                            value: productionCredit.id
                        };
                    }
                );

                this.productionCreditsOptions.unshift({
                    text: "No production credit",
                    value: null
                });
            }
        },
        addressPicked() {
            let self = this;
            self.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    self.details.address = address.address;
                    self.details.zipcode = address.zipcode;
                    self.details.city = address.city;
                    self.details.county = address.county;
                    self.details.state = address.state;
                    self.details.country = address.country;
                }
            });
        }
    }
};
</script>

<style scoped>
.photo {
    width: 100%;
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}
.gap {
    column-gap: 30px;
}
</style>
